import { getConfig } from "./config";

// Prepare the request for the query endpoint
export const prepareRequest = (userMessage, conversationId) => {
  let requestBody = {
    question: userMessage,
    conversation_id: conversationId,
  };
  let method = "POST";

  return { method, requestBody };
};

// Format the response from the query endpoint
export const formatResponse = (data) => {
  // Always return the answer directly
  return data.answer;
};

// Main function to process messages
export const processMessage = async (userMessage, conversationId) => {
  const config = getConfig();
  try {
    const { method, requestBody } = prepareRequest(userMessage, conversationId);
    const endpoint = config.ENDPOINTS.QUERY;

    // Preparar os headers com token e workspace, se disponíveis
    const headers = {
      "Content-Type": "application/json",
    };

    // Adicionar token de autenticação, se disponível
    if (config.AUTH_TOKEN) {
      headers["Authorization"] = config.AUTH_TOKEN;
    }

    // Adicionar workspace, se disponível
    if (config.WORKSPACE) {
      headers["Workspace"] = config.WORKSPACE;
    }

    // Make the API request
    const response = await fetch(`${config.BASE_URL}${endpoint}`, {
      method,
      headers,
      body: method === "POST" ? JSON.stringify(requestBody) : undefined,
    });

    if (!response.ok) {
      if (response.status === 401) {
        throw new Error(
          "Erro de autenticação: Token inválido ou não fornecido"
        );
      }
      throw new Error(`Erro na requisição: ${response.status}`);
    }

    const data = await response.json();
    return formatResponse(data);
  } catch (error) {
    console.error("Erro ao comunicar com o agente:", error);
    throw error;
  }
};
